import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ElementRef, ViewChild} from '@angular/core';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { UtilsService } from 'src/app/shared/utils.service';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-add-edit-event',
    templateUrl: './add-edit-event.component.html',
    styleUrls: ['./add-edit-event.component.scss'],
    standalone: false
})
export class AddEditEventComponent implements OnInit {
  addEventForm!: FormGroup;
  type: string;
  event: any;
  minDate: Date;
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  productCtrl = new FormControl();
  filteredProducts: Observable<string[]>;
  products: any[];
  allProducts: any[];
  isLoading = false;

  @ViewChild('productInput') productInput!: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete!: MatAutocomplete;
  productsList!: any[];
  invalidProducts: boolean;
  user: User;
  constructor(public dialogRef: MatDialogRef<AddEditEventComponent>,
              private dataService: DataService,
              private utils: UtilsService,
              private authService: AuthService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.invalidProducts  = false;
                this.user = this.authService.getUserData()
                this.products = new Array<string>();
                this.allProducts = new Array<string>();
                this.type = data.type;
                this.event = data.event;
                this.minDate = new Date();
                if (this.type === 'Edit' && this.event.products) {
                  this.event.products.forEach((element: any) => {
                    this.products.push(element);
                  });
                }
                this.filteredProducts = this.productCtrl.valueChanges.pipe(
                  startWith(null),
                  map((product: string | null) => product ? this._filter(product) : this.allProducts.slice()));
               }

  ngOnInit(): void {
    this.addEventForm = new FormGroup({
      event_name: new FormControl(this.event ? this.event.name : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      event_description: new FormControl(this.event ? this.event.description : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      event_start_date: new FormControl(this.event ? this.event.startDate : null, [Validators.required]),
      event_end_date: new FormControl(this.event ? this.event.endDate : null, [Validators.required]),
      event_country: new FormControl(this.event ? this.event.country : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      event_city: new FormControl(this.event ? this.event.city : this.event, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      event_venue: new FormControl(this.event ? this.event.venue : this.event, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      event_booth: new FormControl(this.event ? this.event.booth : null, null),
    });
    this.getAllProducts();

  }

  closeDialog() {
    if (this.addEventForm.dirty && this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit() {
    if (this.products.length > 0) {
    } else {
      this.invalidProducts = true;
      this.addEventForm.markAllAsTouched();
      return;
    }

    const productIds = [];
    for (let index = 0; index < this.products.length; index++) {
      const element = this.products[index];
      productIds.push(element.id);
    }

    if (this.addEventForm.valid) {
      const startDate = new Date(this.addEventForm.get('event_start_date')?.value);
      const timeOffsetInMS = startDate.getTimezoneOffset() * 60000;
      startDate.setTime(startDate.getTime() - timeOffsetInMS);
      const endDate = new Date(this.addEventForm.get('event_end_date')?.value);
      endDate.setTime(endDate.getTime() - timeOffsetInMS);
      if (this.type === 'Edit') {
        const payload = {
          eventId: this.event.id,
          name: this.addEventForm.get('event_name')?.value,
          description: this.addEventForm.get('event_description')?.value,
          startDate,
          endDate,
          country: this.addEventForm.get('event_country')?.value,
          venue: this.addEventForm.get('event_venue')?.value,
          city: this.addEventForm.get('event_city')?.value,
          booth: this.addEventForm.get('event_booth')?.value,
          products: productIds,
          productsList: this.products
        };
        this.dataService.put('event/UpdateEvent', payload).then((data: any) => {
          if (data.statusCode === 200) {
            this.dialogRef.close(payload);
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Event information updated successfully',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      } else if (this.type === 'Add') {
        const payload = {
          name: this.addEventForm.get('event_name')?.value,
          description: this.addEventForm.get('event_description')?.value,
          startDate,
          endDate,
          country: this.addEventForm.get('event_country')?.value,
          venue: this.addEventForm.get('event_venue')?.value,
          city: this.addEventForm.get('event_city')?.value,
          booth: this.addEventForm.get('event_booth')?.value,
          products: productIds,
          productsList: this.products,
          departments: null
        };
        this.dataService.post('event/CreateEvent', payload).then((data: any) => {
          if (data.statusCode === 200) {
            payload.startDate = data.data.startDate;
            payload.endDate = data.data.endDate;
            payload.products = this.products;
            payload.departments = data.data.departments;
            const newEventPayload = {payload, id: data.data.id};
            this.dialogRef.close(newEventPayload);

            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Event added successfully',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      }
    } else {
      this.addEventForm.markAllAsTouched();
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (this.products.includes(value.trim())) {
        this.products.push({
          id: Math.random(),
          name: value.trim()
        });

        this.invalidProducts = false;
      }
    }
    if (input) {
      input.value = '';
    }
    this.productCtrl.setValue(null);
  }

  remove(product: any, index: any): void {
    if (index >= 0) {
      this.products.splice(index, 1);
      if (this.products.length > 0) {
        this.invalidProducts = false;
      } else {
        this.invalidProducts = true;
      }
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    let productExist = false;
    for (let index = 0; index < this.products.length; index++) {
      const element = this.products[index];
      if (element.id === event.option.value.id) {
        productExist = true;
      }
    }
    if (!productExist) {
      this.products.push(event.option.value);
    }
    this.productInput.nativeElement.value = '';
    this.productCtrl.setValue(null);
    if (this.products.length > 0) {
      this.invalidProducts = false;
    } else {
      this.invalidProducts = true;
    }
  }

  private _filter(value: any): any[] {
    return this.allProducts.filter(product => product.name.toLowerCase().includes(value));
  }

  searchProduct(event: any) {
    this.isLoading = true;
    this.dataService.get('product/RetrieveProductsByName?searchKeyword=' + this.productInput.nativeElement.value, true).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        this.allProducts = [];
        this.productsList = data.data.records;
        this.productsList.forEach((productData) => {
          this.allProducts.push(productData);
        });
        this.filteredProducts = this.productCtrl.valueChanges.pipe(
          startWith(null),
          map((product: string | null) => product ? this._filter(product) : this.allProducts.slice()));
        this.isLoading = false;
      }
      });
  }

  getAllProducts() {
    this.isLoading = true;
    this.dataService.get('product/RetrieveProductsByName?searchKeyword=', true).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        this.allProducts = [];
        this.productsList = data.data.records;
        this.productsList.forEach((productData) => {
          this.allProducts.push(productData);
        });
        this.filteredProducts = this.productCtrl.valueChanges.pipe(
          startWith(null),
          map((product: string | null) => product ? this._filter(product) : this.allProducts.slice()));
      }
      this.isLoading = false;
      });
  }
}
